import script from "./HelpDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpDownload.vue?vue&type=script&setup=true&lang=ts"

import "./HelpDownload.vue?vue&type=style&index=0&id=1c850bdc&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c850bdc"]])

export default __exports__